// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_2b-sj","productBadge":"_3ti1l","badge":"_2jKdC","defaultImage":"_1esk9"};